import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    title: 'Je betaling is gelukt, bedankt!',
    linkText: 'Naar je facturen',
  },
  en: {},
};
